import debounce from '../modules/debounce'

const footer = document.querySelector('.footer')
const mainContent = document.querySelector('main')

function setFooterSpacing() {
  const footerHeight = footer.getBoundingClientRect().height

  //Check if screen height is tall enough to enable reveal effect
  if (window.innerHeight >= footerHeight) {
    //Enable reveal effect
    footer.style.position = 'fixed'
    mainContent.style.marginBottom = footerHeight + 'px'
  } else {
    //Disable reveal effect
    footer.style.position = 'static'
    mainContent.style.marginBottom = 0
  }
}

window.addEventListener('resize', debounce(setFooterSpacing, 100))

setFooterSpacing()
